import { render, staticRenderFns } from "./router.vue?vue&type=template&id=f2f3253e&"
import script from "./router.vue?vue&type=script&lang=js&"
export * from "./router.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports